import Vue from "vue";

export default {
  tickerMatches(state, matches) {
    state.ticker.matches = matches;
  },
  updateTickerMatch(state, { _id, match }) {
    let index = state.ticker.matches.findIndex(m => m._id === _id);
    if (index >= 0) Vue.set(state.ticker.matches, index, { ...match });
  },
  createTickerMatch(state, { _id, match }) {
    let index = state.ticker.matches.findIndex(m => m._id === _id);
    if (index >= 0) return;
    state.ticker.matches.push(match);
  },
  deleteTickerMatch(state, _id) {
    let index = state.ticker.matches.findIndex(m => m._id === _id);
    if (index >= 0) state.ticker.matches.splice(index, 1);
  }
};
